import { render } from "./LoyaltyWidget.vue?vue&type=template&id=d91f62ea"
import script from "./LoyaltyWidget.vue?vue&type=script&lang=js"
export * from "./LoyaltyWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__